// @flow
import * as React from 'react';
import HiddenField from 'app/default/field/HiddenField';

const SendConfirmEmailField = () =>
    <HiddenField name="send_confirm_email" value={true} />;

export default SendConfirmEmailField;
